// NPM
import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from "recoil";
import { isNil, isEmpty, map, isArray, forEach } from 'lodash';
import { generateCode } from 'Helpers/generate-code';

// ANT COMPONENT
import { Space, Radio, Divider } from 'antd';
import { BasicModal, Button, RadioChangeEvent } from '@life-line-lab/components-react';

// HELPER
import { toaster, encode, decode } from 'Helpers/index';

// PAYMENT VALUES JSON
import PaymentType from 'Data/payment-type.json';

// Services
import { createOrder, updateCartItem, fetchCartList } from 'Services/order.services';

// Atom
import { orderAtom, LocalCartAtom } from "Recoil/order.atom";

// STYLE
import './product-proceed.scss';
import { createRePaymentObject, CreateRePaymentObjectPayload } from 'Services/payment.services';
import useSession from 'Hooks/session.hook';
import { InvalidVoucherStatusType } from 'Components/order/purchase-list/purchase-list';
import { fetchProductData } from 'Services/inventory.services';
import { DiscountVoucherInvalidModal } from 'Components/order/payment-list/modals/discount-voucher-invalid-modal';

const PaymentMethods = PaymentType.filter(elem => elem.hidden !== true);

const EWalletList = PaymentMethods.find(elem => elem.groupBy === 'e-wallet');
const InternetBankingList = PaymentMethods.find(elem => elem.groupBy === 'internet-banking');

const ProductProceed = () => {
  const history = useHistory<any>();
  const { t } = useTranslation();

  const [paymentCode, setPaymentCode] = useState<number>();
  const [groupBy, setGroupBy] = useState<'internet-banking'|'e-wallet'>();
  const [orderState, setOrderState] = useRecoilState<any>(orderAtom);
  const [localCartState, setLocalCartState] = useRecoilState<any>(LocalCartAtom);
  const [carListItems, setCarListItems] = useState<any>({});
  const { profile } = useSession();
  const [invalidVoucherPopup, setInvalidVoucherPopup] = useState<boolean>(false);
  const [appliedInvalidVouchers, setAppliedInvalidVouchers] = useState<any[]>([])
  const [appliedInvalidVoucherStatus, setAppliedInvalidVoucherStatus] = useState<InvalidVoucherStatusType>('EXPIRED')

  const STORAGE_KEY = 'TEMP_CREATE_ORDER_DATA';
  let createOrderData: any;
  let totalAmount: any;
  let totalShipping: any;
  let totalToPay: any;

  const isRepayment = history.location?.state?.isRepayment
  const paymentDetails = history.location?.state?.paymentDetails

  if (isRepayment) {
    totalAmount = paymentDetails.subTotal;
    totalShipping = paymentDetails.shippingFee;
    totalToPay = paymentDetails.total;
  } else {
    createOrderData = JSON.parse(localStorage.getItem(STORAGE_KEY) as string);
    totalAmount = createOrderData.totalAmount;
    totalShipping = createOrderData.totalShipping;
    totalToPay = createOrderData.totalToPay;
  }

  console.log({ createOrderData, paymentCode });

  useEffect(() => {
    const fetchCartListItems = async () => {
      const responseData = await fetchCartList();
      if (!isNil(responseData) && responseData.cartID) {
        setCarListItems(responseData)
      }
    }

    fetchCartListItems()
  }, []);

  const onRadioChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    if (value === 'internet-banking' || value === 'e-wallet') {
      setGroupBy(value);
      setPaymentCode(undefined);
      return;
    }

    if (value === 2.1 || value === 2.2 || value === 3) { // if they choose fpx or bank card
      setGroupBy(undefined); // want to hide the list
      setPaymentCode(value);
      return;
    }

    setPaymentCode(value);
  }

  const onCloseRepaymentModal = () => {
    setInvalidVoucherPopup(false);
  }

  const handleSubmit = async () => {
    setOrderState({ ...orderState, status: { ...orderState.status, create: 'loading' } });

    let responseData: any;

    if (!isRepayment) {
      responseData = await createOrder(createOrderData);
    }

    // To make sure paymentCode with decimal become integer, eg: 2.1 -> 2
    const paymentCodeStr = parseInt(paymentCode?.toString() as string);

    // if (!isNil(responseData) && !isNil(responseData.paymentID)) {
    if (isRepayment || (!isNil(responseData) && !isNil(responseData.orders))) {
      let orderIDs: any[] | null;
      if (isRepayment) {
        orderIDs = history.location?.state?.orderIdList
      } else {
        orderIDs = !isEmpty(responseData.orders) ? map(responseData.orders, (order) => order._id) : null;
      }

      const encodedOrderIDs = encode(JSON.stringify(orderIDs));

      if (!isRepayment) {
        setOrderState({
          ...orderState,
          status: { ...orderState.status, create: 'success' },
        });
      }

      if (!isRepayment && !localCartState.fromBuyNow) {
        const savedCheckoutData = localCartState.list;

        let latestCartList: any;

        if (savedCheckoutData.length == carListItems.items.length) {
          latestCartList = [];
        } else {
          // map(savedCheckoutData, item => {
          //   latestCartList = filter(carListItems.items, obj => {
          //     return item.cartID != obj.cartID
          //   })
          // })
          latestCartList = carListItems.items.filter(obj =>
            savedCheckoutData.every(item => !item.cartID.includes(obj.cartID))
          );
        }

        let obj = {
          cardId: carListItems.cartID,
          items: latestCartList
        }
        const cartResponse = await updateCartItem(obj);
        if (cartResponse) {
          setLocalCartState({
            ...localCartState, list: []
          });

          history.push(`/payment/submit?ref=${encodedOrderIDs}&type=${paymentCodeStr}`);
        }
      } else {
        setLocalCartState({
          ...localCartState, list: [], fromBuyNow: false,
        });

        if (isRepayment) {
          // * if is kiplepay
          // * Call the repayment API
          const orderIdList = history.location?.state?.orderIdList
          const paymentObj: CreateRePaymentObjectPayload = {
            paymentID: paymentDetails._id,
            orderIDs: !isEmpty(orderIdList) ? orderIdList : null,
            shipName: profile.fullName,
            email: profile.primaryEmail,
            phone: profile.primaryPhone.fullNumber,
            appliedPlatformVouchers: localCartState?.appliedPlatformVouchers,
            paymentBetween: "USER_PLATFORM",
            revpay_payment_code: !isNil(paymentCodeStr) ? parseInt(String(paymentCodeStr)) : undefined
          };

          const result: { error?: any, [key: string]: any} = await createRePaymentObject(paymentObj);

          if (result.error) {
            // * if is actual ERROR, display error message, then RETURN
            const errorInfo = result.error.info;
            if (errorInfo && errorInfo?.timeLimitExceeded) {
              toaster('error', t('toaster.repaymentTimeLimitExceeded'));
              return;
            }
            if (!errorInfo || !errorInfo?.voucherCode) {
              toaster('error', t('toaster.failedValidateOrderForPayment'));
              return;
            }

            // * if is invalid voucher, display accordingly
            let voucherErrorInfo: { voucherCode: string, voucherStatus: InvalidVoucherStatusType } = errorInfo;
            const invalidVoucher = voucherErrorInfo.voucherCode;
            const invalidVoucherList = [invalidVoucher]
            setAppliedInvalidVouchers(invalidVoucherList)
            setAppliedInvalidVoucherStatus(voucherErrorInfo.voucherStatus)
            setInvalidVoucherPopup(true)
            return;
          }

          history.push(`/payment/submit?ref=${encodedOrderIDs}&type=${paymentCodeStr}`, {
            isRepayment: true,
            data: result,
          });
          return;
        }

        // if is NOT repayment
        history.push(`/payment/submit?ref=${encodedOrderIDs}&type=${paymentCodeStr}`);
      }
    }
    else {
      const {code,message} = responseData?.error;
      setOrderState({
        ...orderState,
        status: { ...orderState.status, create: 'error' }
      });
      toaster('error', `${t('toaster.FailedToCreateOrder')}. \n ${message}`)
    }
  }

  const handleCheckoutPreviousOrderWithPendingPayment = async () => {
    const orderObj = history.location?.state?.orderObj;
    const itemsToAdd: any[] = orderObj.items;
    const cartList: any[] = [];
    let totalWeight = 0;

    for (const item of itemsToAdd) {
      const productData = await fetchProductData({ inventoryID: item.inventoryID });

      // * refer product-details.tsx
      const productType = productData.product.productType;
      let productUOMs: any = {};
      if (!isEmpty(productData.product?.baseUOM) || !isEmpty(productData.product?.stockUOMs)) {
        productUOMs[productData.product?.baseUOM.uom] = productData.product?.baseUOM.weight?.value || "0"
        forEach(productData.product?.stockUOMs, uomObj => {
          productUOMs[uomObj.uom] = uomObj.weight?.value || "0"
        })
      }
      let itemWeight = item.weight?.value ?? item.weight ?? productUOMs[item.uom];

      const cartDetails = {
        cartID: generateCode('CRT-'),
        productData: productData,
        selectedVariant: productData.stockVariants.find(s => s.variantCode === item.variantCode),
        quantity: item.quantity,
        weight: productType != 'VOUCHER' ? parseFloat(itemWeight) * parseFloat(item.quantity) : 0
      }

      if (productType !== 'VOUCHER'&& productType !== 'NO_SHIPPING') {
        totalWeight += parseFloat(itemWeight) * parseFloat(item.quantity)
      }

      cartList.push(cartDetails)
    }

    const shippingCostObj = {
      orders: [
        {
          supplierID: itemsToAdd[0].product.orgID,
          state: profile.primaryAddress.state,
          weight: totalWeight,
        },
      ]
    }
    setLocalCartState({
      ...localCartState, list: [...cartList], fromBuyNow: true, shippingCostObj,
    });
    history.push('/checkout', {
      isCancelPreviousOrder: true,
      cancelOrderObj: orderObj,
    });
  }

  return (
    <div className="p-20 m-20 product-proceed--page">
      {/* Web View */}
      <Space className="product-proceed--container" direction="vertical" size="small">
        <h2>{t('label.paymentMethod')}</h2>
        <Radio.Group name="paymentMethod" buttonStyle="solid">
          <Space size="small" wrap={true}>
            {PaymentMethods.map((payment, idx) => (
              <Radio.Button
                className="flex items-center md:h-auto"
                key={idx}
                value={payment.paymentID || payment.groupBy}
                onChange={(e) => onRadioChange(e)}
              >
                <Space size="small">
                  <span className="text-blue-800 font-bold">
                    {payment.type || payment.groupBy}
                  </span>

                  <div>
                    {payment.iconPath && isArray(payment.iconPath) ?
                      payment.iconPath.map(icon => <img key={icon} src={icon}/>)
                      :
                      payment.iconPath && !isArray(payment.iconPath) ? <img src={payment.iconPath}/>
                      :
                      null
                    }
                  </div>
                </Space>
              </Radio.Button>
            ))}
          </Space>
        </Radio.Group>

        <Divider/>

        <div>
          {groupBy === 'internet-banking' ?
            <Radio.Group name="internetBanking">
              <Space direction="vertical" size="middle">
                {InternetBankingList?.list?.map(elem => (
                  <Radio key={elem.paymentID} value={elem.paymentID} onChange={onRadioChange}>
                    <Space className="ml-10" size="middle">
                      <img src={elem.iconPath}/>
                      <span className="radio-label">{elem.type}</span>
                    </Space>
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
            :
            null
          }

          {groupBy === 'e-wallet' ?
            <Radio.Group name="eWallet">
              <Space direction="vertical" size="middle">
                {EWalletList?.list?.map(elem => (
                  <Radio key={elem.paymentID} value={elem.paymentID} onChange={onRadioChange}>
                    <Space className="ml-10" size="middle">
                      <img src={elem.iconPath}/>
                      <span className="radio-label">{elem.type}</span>
                    </Space>
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
            :
            null
          }
        </div>

        <Divider/>

        <Space className="product-proceed--footer" align="end" direction="vertical" size="middle">
          <div className="display-amount">
            <span>{t('label.productSubtotal')}</span>
            <span>RM{parseFloat(totalAmount).toFixed(2)}</span>
          </div>

          <div className="display-amount">
            <span>{t('label.shippingTotal')}</span>
            <span>RM{parseFloat(totalShipping).toFixed(2)}</span>
          </div>

          <div className="display-amount">
            <span/>
            <span>RM{parseFloat(totalToPay).toFixed(2)}</span>
          </div>

          <Button
            type="secondary"
            label={t('action.placeOrder')}
            isDisabled={!paymentCode}
            isLoading={orderState.status === 'loading'}
            onClick={handleSubmit}
          />
        </Space>
      </Space>

      <DiscountVoucherInvalidModal
        appliedInvalidVoucherStatus={appliedInvalidVoucherStatus}
        appliedInvalidVouchers={appliedInvalidVouchers}
        handleCheckoutPreviousOrderWithPendingPayment={handleCheckoutPreviousOrderWithPendingPayment}
        invalidVoucherPopup={invalidVoucherPopup}
        onCloseModal={onCloseRepaymentModal}
      />
    </div>
  )
}

export default ProductProceed;
